// extracted by mini-css-extract-plugin
export default {"label_container":"InfoLabel_label_container__8lehY","readMore":"InfoLabel_readMore__7ZODj"};